

















import { Component } from 'vue-property-decorator';
import BaseLogin from '@/views/auth/BaseLogin';
import { PostAuthTokenRequest, AuthToken } from 'ncp-api-supporter';
import { i18n } from '@/main';
import { getPlanLabel } from '@/utils/common';
import { loginToEnterpriseAdmin, setSessionCookie, setToken } from '@/utils/token';
import { getCookie } from '@/utils/cookie';
import { SHOPBY_ACCESSTOKEN } from '@/const/cookie';
import { SecondAuthData } from '@/const/contents/auth';
import { Getter, Mutation } from 'vuex-class';
import { Admin } from '@/types';
import AuthSecondPopup from '@/views/auth/authPopups/AuthSecondPopupIframe.vue';
import DuplicateLoginCheckPopup from '@/views/auth/authPopups/DuplicateLoginCheckPopup.vue';


const { VUE_APP_REDIRECT_URL, VUE_APP_NODE_ENV, VUE_APP_COMMERCE_MAIN } = process.env;

@Component({
  components: {
    AuthSecondPopup,
    DuplicateLoginCheckPopup,
  },
})
export default class OauthCodeReceiver extends BaseLogin {
  @Mutation('admin/SET_ADMIN') private setAdmin!: (admin: Admin) => void;

  @Getter('admin/getAdmin')
  private readonly admin: Admin | undefined;

  private secondAuthData: SecondAuthData = {
    key: '',
    plan: '',
    target: {
      email: '',
      enableOtp: false,
      mobile: '',
    },
    type: '',
    types: [],
  };

  private openPopupName = '';

  private openPopup(popupName: string): void {
    this.openPopupName = popupName;
  }

  private closePopup() {
    this.openPopupName = '';

    if (!getCookie(SHOPBY_ACCESSTOKEN)) {
      window.location.href = '/pro/auth';
    }
  }

  private completeSecondAuth(authToken: AuthToken) {
    this.setTokenData(authToken);

    alert('관리자 접속이 승인되었습니다.');
    this.openPopup('DuplicateLoginCheckPopup');
  }

  private async moveRoot() {
    await this.redirectAfterLogin(this.$route.query?.state?.toString() ?? '');
  }

  private setTokenData(authToken: AuthToken) {
    const { accessToken, refreshToken, autoLogoutMin } = authToken;
    const admin = setToken(accessToken, refreshToken, autoLogoutMin);

    setSessionCookie();

    if (admin) {
      this.setAdmin(admin);
    }
  }

  private postTokenHandler() {
    const code = this.$route.query?.code?.toString();
    code && this.postAuthToken(code);
  }

  private postAuthToken(code: string) {
    const request: PostAuthTokenRequest = {
      data: {
        adminType: 'SERVICE',
        grantType: 'OAUTH_CODE',
        code,
      },
    };

    if (VUE_APP_NODE_ENV === 'local') {
      request.data.redirectUrl = `${VUE_APP_REDIRECT_URL}/oauth/redirect`;
    }

    this.$api
      .postAuthToken(request)
      .then(res => {
        if (res.data.planType === 'STANDARD') {
          loginToEnterpriseAdmin(res.data);

          return;
        }

        if (res.data.planType === 'PREMIUM') {
          alert(i18n.t('ALERT_CHECK_PLAN_TYPE', { planType: getPlanLabel(res.data.planType) }));
          window.location.href = process.env.VUE_APP_PREMIUM_ADMIN_URL;

          return;
        }

        this.setTokenData(res.data);
        this.openPopup('DuplicateLoginCheckPopup');
      })
      .catch(e => {
       if (e.data.status === 400 && e.data.code && e.data.code.includes('AU1001')) {
          this.secondAuthData = {
            ...this.secondAuthData,
            ...e.data.body,
          };

          this.openPopup('AuthSecondPopup');
          return;
        }
        alert(e.data.message);

        window.open(VUE_APP_COMMERCE_MAIN, '_self');
      });
  }

  created() {
    this.postTokenHandler();
  }
}
